export const printHtml = (html) => {

	const closePrint = (oHideFrame) => {
		document.body.removeChild(oHideFrame);
	}
	const setPrint = (oHideFrame) => {
		oHideFrame.contentWindow.__container__ = this;
		oHideFrame.contentWindow.onbeforeunload = () => closePrint(oHideFrame);
		oHideFrame.contentWindow.onafterprint = () => closePrint(oHideFrame);
		oHideFrame.contentWindow.focus(); // Required for IE
		oHideFrame.contentWindow.print();
	}
	const printPage = () => {
		var oHideFrame = document.createElement("iframe");
		oHideFrame.onload = ()=>setPrint(oHideFrame);
		oHideFrame.style.position = "fixed";
		oHideFrame.style.right = "0";
		oHideFrame.style.bottom = "0";
		oHideFrame.style.width = "0";
		oHideFrame.style.height = "0";
		oHideFrame.style.border = "0";
		oHideFrame.srcdoc = html;
		document.body.appendChild(oHideFrame);
	}
	return printPage();
}

export const tempInvoice = `<html>

<body class="ck-content" style="font-family: Arial, Helvetica, sans-serif">
    <div id="header">
        <img class="image_resized" style="width:100%;" src="#LOGO_LINK" alt="header">
    </div>
    <div id="body" style="min-height: 680px;">
        <div>
            <table style="width: 100%;">
                <tr>
                    <td colspan="2">
                        <p style="font-size:13px;margin:3px 0;text-transform:uppercase;font-weight:bold;">BILL
                            #INVOICE_NUMBER</p>
                    </td>
                    <td colspan="2">
                        <p style="font-size:13px;margin:3px 0;text-transform:uppercase;font-weight:bold;">Invoice</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p style="font-size:13px;margin:3px 0;">Customer</p>
                        <p style="font-size:13px;margin:3px 0;">Name</p>
                        <p style="font-size:13px;margin:3px 0;">Address</p>
                    </td>
                    <td>
                        <p style="font-size:13px;margin:3px 0;"><span>#CUSTOMER_CODE</span>&nbsp;</p>
                        <p style="font-size:13px;margin:3px 0;"><span>#CUSTOMER_NAME&nbsp;</span></p>
                        <p style="font-size:13px;margin:3px 0;"><span>#ADDRESS</span></p>
                    </td>
                    <td>
                        <p style="font-size:13px;margin:3px 0;">Invoice</p>
                        <p style="font-size:13px;margin:3px 0;">Invoice Date</p>
                        <p style="font-size:13px;margin:3px 0;">Due Date</p>
                        <p style="font-size:13px;margin:3px 0;">&nbsp;</p>
                    </td>
                    <td>
                        <p style="font-size:13px;margin:3px 0;"><span>#INVOICE_NUMBER</span>&nbsp;</p>
                        <p style="font-size:13px;margin:3px 0;"><span>#INVOICE_DATE</span></p>
                        <p style="font-size:13px;margin:3px 0;"><span>#DUE_DATE</span>&nbsp;</p>
                        <p style="font-size:13px;margin:3px 0;">&nbsp;</p>
                    </td>
                </tr>
            </table>
            <table style="width: 100%;">
                <tr>
                    <td style="width:70%;">
                        <div>
                            <div
                                style="display:block;width:100%;overflow-x:auto;box-sizing:border-box;font-size:.875rem;line-height:1.5;text-align:left">
                                <table style="width:100%;border: 1px solid black;border-collapse: collapse;">
                                    <thead>
                                        <tr>
                                            <th
                                                style="border: 1px solid black;border-collapse: collapse;padding-left: 0.5rem;width:10%;font-weight: normal;">
                                                Product</th>
                                            <th
                                                style="border: 1px solid black;border-collapse: collapse;padding-left: 0.5rem;width:30%;font-weight: normal;">
                                                Description</th>
                                            <th
                                                style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;font-weight: normal;">
                                                Quantity</th>
                                            <th
                                                style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;font-weight: normal;">
                                                Unit Price</th>
                                            <th
                                                style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;font-weight: normal;">
                                                Discount</th>
                                            <th
                                                style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;font-weight: normal;">
                                                Tax Amount</th>
                                            <th
                                                style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;font-weight: normal;">
                                                Sub Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        #ITEM_INFO
                                    </tbody>
                                </table>
                            </div>
                            <table style="width: 100%; border-collapse: collapse;margin-top: 5px">
                                <tr>
                                    <td style="width: 62%;"></td>
                                    <td style="font-size:.875rem;width:38%">
                                        <table style="width:100%;border-collapse:collapse">
                                            <tbody>
                                                <tr>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>Total Net Amount</span>
                                                    </td>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span> #TOTAL_NET_AMOUNT</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>Total Discount Amount</span>
                                                    </td>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span> #TOTAL_DISCOUNT_AMOUNT</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>Total Tax Amount</span>
                                                    </td>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span> #TOTAL_TAX_AMOUNT</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>Total Amount</span>
                                                    </td>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>#TOTAL_AMOUNT</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>Overdue Amount</span>
                                                    </td>
                                                    <td style="border-collapse: collapse;padding: 0.5rem;">
                                                        <span>
                                                            #OVERDUE_AMOUNT
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div id="footer">
        <div style="padding: 5px 0;">
            <img class="image_resized" style="width:100%;" src="#FOOTER_LINK" alt="footer">
        </div>
    </div>
</body>

</html>`;

export const tempItemInvoice = `<tr>
    <td style="border: 1px solid black;border-collapse: collapse;padding-left: 0.5rem;width:10%;">
        <span style="margin-right:.25rem!important">#ITEM_NAME</span><span
            style="border:0.5px solid;display:inline-block;padding:.25em .4em;font-size:75%;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem">#ITEM_NAME</span>
    </td>
    <td style="border: 1px solid black;border-collapse: collapse;padding-left: 0.5rem;width:20%;">
        <span style="margin-right:.25rem!important">#ITEM_NAME</span>
    </td>
    <td
        style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;">
        #ITEM_QUANTITY</td>
    <td
        style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;">
        <span> #ITEM_UNIT_PRICE</span>
    </td>
    <td
        style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;">
        <span> #ITEM_DISCOUNT</span>
    </td>
    <td
        style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;">
        <span> #TAX_AMOUNT</span>
    </td>
    <td
        style="text-align:right!important;border: 1px solid black;border-collapse: collapse;padding-right: 0.5rem;width:8%;">
        <span> #SUB_TOTAL</span>
    </td>
</tr>`